import React, { useEffect, useState } from "react";
import "./KPISection.css";

const KPISection = () => {
  const [width, setWidth] = useState(null);

  useEffect(() => {
    // Run only on client-side
    const updateWidth = () => setWidth(window.innerWidth);

    updateWidth(); // Set initial width
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width === null) return null; // Prevent server-side render crash

  const containerClass = width <= 768 ? "kpi-container mobile" : "kpi-container";

  const kpis = [
    { value: "37%", label: "Revenue Uplift" },
    { value: "10+ years", label: "Managing Properties" },
    { value: "87%", label: "5 Star Reviews" },
    { value: "500k+", label: "Bookings Managed" },
  ];

  return (
    <section id="section-reviews-section" className={containerClass}>
      <div className="kpi-grid">
        {kpis.map((kpi, index) => (
          <div key={index} className="kpi-item">
            <div className="kpi-value">{kpi.value}</div>
            <div className="kpi-label">{kpi.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default KPISection;